// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar__avatar___5fo6b","small":"Avatar__small___zT61A","medium":"Avatar__medium___e6vme","large":"Avatar__large___Kzn4U","unknown":"Avatar__unknown___8zKk-"};